import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const emptyFieldMappingValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const keys = Object.keys(control.value).filter(key => !key.includes('search_only_'));
  if (keys.length === 0) {
    return null;
  } else {
    let empty = true;
    for (const key of keys) {
      if (control.value[key]) {
        empty = false;
        break;
      }
    }
    return empty ? { 'empty-field-mapping': true } : null;
  }
};
